// extracted by mini-css-extract-plugin
module.exports = {"outsideButtonContainer":"styles_outsideButtonContainer__Yqmr6","claimModal":"styles_claimModal__l32IK"};